import { parsePercent, formatPercent } from '@/utils/number-functions';

export default {
	format: (input, e) => {
		if (['keyup', 'blur', 'mounted'].includes(e.type)) {
			console.log('percent-mask');
			// appends % to value, validates decimal side
			// and puts cursor back in right position.
			//debugger;
			// get input value

			var input_val = input.value.replace('%', '');
			// don't validate empty input
			if (input_val === '' || input_val === '.') {
				return;
			}

			// original length
			var original_len = input_val.length;

			// initial caret position
			var caret_pos = input.selectionStart;

			// check for decimal
			if (input_val.indexOf('.') >= 0) {
				// get position of first decimal
				var decimal_pos = input_val.indexOf('.');
				// split number by decimal point
				var left_side = input_val.substring(0, decimal_pos);
				var right_side = input_val.substring(decimal_pos);
				// this prevents multiple decimals from
				// being entered
				right_side = right_side.replaceAll('.', '');
				right_side = '.' + right_side;

				// Limit left of decimal to only 2 digits
				left_side = left_side.substring(0, 2);
				if (!left_side) left_side = '0';
				//right_side = formatPercent(right_side);
				//left_side = formatPercent(left_side);
				input_val = left_side + right_side + '%';
			} else {
				// no decimal entered
				// final formatting
				input_val = formatPercent(input_val);
				input_val = input_val.substring(0, 2);
				if (e.type === 'blur' || !input_val.includes('%')) {
					input_val += '.00%';
				}
			}

			// send updated string to input
			input.value = input_val;

			// put caret back in the right position
			var updated_len = input_val.length;
			caret_pos = updated_len - original_len + caret_pos;
			input.setSelectionRange(caret_pos, caret_pos);
		}
	},
	parse: formattedVal => {
		let parsedVal = 0;

		if (formattedVal) {
			parsedVal = parsePercent(formattedVal);
		}

		return parsedVal;
	}
};
